"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var ItemCommon_1 = __importDefault(require("@features/ItemCommon"));
var VersionInfo_1 = __importDefault(require("../VersionInfo"));
function OlderJobVersions(_a) {
    var showOldJobs = _a.showOldJobs, toggleJobs = _a.toggleJobs, scrollToLatestJob = _a.scrollToLatestJob, jobs = _a.jobs, template = _a.template, domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, updateItemCurrent = _a.updateItemCurrent, updateItemCustomerSpecific = _a.updateItemCustomerSpecific, updateFeedback = _a.updateFeedback, updateModerationNotes = _a.updateModerationNotes, isUsingImageGallery1 = _a.isUsingImageGallery1, isUsingImageGallery2 = _a.isUsingImageGallery2, editPermissions = _a.editPermissions, onSelectDecision = _a.onSelectDecision;
    var t = (0, react_i18next_1.useTranslation)().t;
    var itemCommonProps = {
        domain: domain,
        updateItemCurrent: updateItemCurrent,
        updateItemCustomerSpecific: updateItemCustomerSpecific,
        angularJsDependencies: angularJsDependencies,
        isUsingImageGallery1: isUsingImageGallery1,
        isUsingImageGallery2: isUsingImageGallery2,
        updateFeedback: updateFeedback,
        editPermissions: editPermissions,
        template: template,
        updateModerationNotes: updateModerationNotes,
        onSelectDecision: onSelectDecision,
    };
    var MAX_NUMBER_OF_DIVIDERS = 4;
    var getNumberOfDividers = function () {
        return jobs.length > MAX_NUMBER_OF_DIVIDERS ? MAX_NUMBER_OF_DIVIDERS : jobs.length;
    };
    var getJobNumberText = function () {
        if (!jobs) {
            return '';
        }
        return t('MODERATION.QUEUE_VIEW.JOB_VERSION.NUMBER_OF_VERSIONS', { count: jobs.length });
    };
    return (react_1.default.createElement("div", { className: "older-job-versions" },
        react_1.default.createElement("div", { className: "first-row" },
            react_1.default.createElement("div", { onClick: toggleJobs },
                react_1.default.createElement("i", { className: "eva-old-job-version-button-icon implioicons-enlarge cursor-pointer" }),
                react_1.default.createElement("span", { className: "job-number-text cursor-pointer" }, getJobNumberText()),
                react_1.default.createElement("span", { className: " more-info-tooltip implioicons-question-mark-filled eva-tooltip-container--center cursor-pointer" },
                    react_1.default.createElement("span", { className: "eva-tooltip info-revision-tooltip" }, t('MODERATION.QUEUE_VIEW.JOB_VERSION.TOOLTIP'))))),
        !showOldJobs && (react_1.default.createElement("div", { onClick: toggleJobs }, Array.from({ length: getNumberOfDividers() }).map(function (_, index) { return (react_1.default.createElement("hr", { key: index, className: "version-divider" })); }))),
        showOldJobs &&
            jobs.map(function (job, index) {
                var _a;
                var jobToDisplay = Object.assign(Object.create(Object.getPrototypeOf(job)), job);
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement(VersionInfo_1.default, { historyItem: (_a = jobToDisplay === null || jobToDisplay === void 0 ? void 0 : jobToDisplay.ad) === null || _a === void 0 ? void 0 : _a.history[0], hideLink: false, onLinkClicked: scrollToLatestJob }),
                    react_1.default.createElement("div", { className: "eva-job flex-container" },
                        react_1.default.createElement(ItemCommon_1.default, __assign({ job: jobToDisplay, index: index, hideReviewBar: true }, itemCommonProps, { showModerationNoteIndicator: false, enableKeyboardShortcuts: false, editMode: false })))));
            })));
}
exports.default = OlderJobVersions;
